<script setup>

import FileUpload from "primevue/fileupload";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import {computed, onMounted, ref} from "vue";
import {router} from "@inertiajs/vue3";

const props = defineProps({
    interactive: Boolean,
    full: Boolean
})
const src = defineModel('src')
const loading = ref(false);
const error = ref(null);
function onFileSelect(event) {
    loading.value = true;
    error.value = null;
    const file = event.files[0];
    let formData = new FormData();
    formData.append("file", file);
    axios.post('/app/upload', formData, {
        headers: {
            'Content-Type': file.type
        }
    }).then((res) => {
        src.value = res.data.path;
        loading.value = false;
    }).catch((err) => {
        error.value = err.response.data.message;
    })
}

const previewStyle = computed(() => {
    if (props.interactive) {
        return 'width: 180px;height: 80px'
    }
    return `width: 180px;height: 130px`
})

const imageStyle = computed(() => {
    if (props.interactive) {
        return 'height: 80px'
    }
    return `height: 130px`
})

const uploader = ref()

</script>

<template>
    <FileUpload @select="onFileSelect" customUpload auto severity="secondary" ref="uploader" class="border-0">
        <template #header>
            <div></div>
        </template>
        <template #empty>
            <div v-if="!src"
                 :class="[interactive ? 'border-black dark:border-white ' : '', full ? 'w-full h-full' : 'w-[180px] border border-dashed']"
                 class="p-4 px-6  flex cursor-pointer flex-col gap-2 text-sm items-center text-center rounded-xl"
                 @click="uploader.choose()">
                <template v-if="!loading && !error">
                    <i class="pi pi-plus " :class="interactive ? '' : 'opacity-30'" style="font-size: 3rem"></i>
                    {{ $t('common.upload_image') }}
                </template>
                <template v-else-if="!!error">
                    <i class="pi pi-times" :class="interactive ? '' : 'opacity-30'" style="font-size: 3rem"></i>
                    {{ error }}
                </template>
                <template v-else>
                    <i class="pi pi-spinner pi-spin" :class="interactive ? '' : 'opacity-30'" style="font-size: 3rem"></i>
                </template>
            </div>
        </template>
        <template #content>
            <div v-if="src" class="relative" :style="previewStyle">
                <div class="absolute -top-2 z-10 -right-2">
                    <Button icon="pi pi-times" rounded severity="secondary"  @click="() => {
                        uploader.remove()
                        src = null;
                    }"></Button>
                </div>
                <img v-if="src" :src="src" alt="Image" :class="{
                    'shadow-md': !interactive,
                    'border border-dashed border-black dark:border-white p-2': interactive
                }" class=" rounded-xl w-full sm:w-64 object-contain absolute top-0 content-center" :style="imageStyle"/>
            </div>
        </template>
    </FileUpload>
</template>

<style scoped>
.p-fileupload {
    border-width: 0!important;
    background-color: transparent!important;
}


:deep(.p-fileupload-header) {
    display: none;
}

:deep(.p-fileupload-content) {
    padding: 0;
}

</style>
